"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _BrandUtil = require("../../../utils/BrandUtil");

var _reactHelmet = require("react-helmet");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Seo = function Seo(_ref) {
  var brandTag = _ref.brandTag,
      title = _ref.title,
      description = _ref.description,
      robots = _ref.robots;

  var brand = _BrandUtil.BrandUtil.getBrand(brandTag);

  var data = _BrandUtil.BrandUtil.content(brand);

  var name = data.name,
      favIcon = data.favIcon,
      googleAnalytics = data.googleAnalytics;
  var merchantId = googleAnalytics.merchantId,
      gtmId = googleAnalytics.gtmId;
  return /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react["default"].createElement("meta", {
    charSet: "utf-8"
  }), /*#__PURE__*/_react["default"].createElement("meta", {
    httpEquiv: "Content-Language",
    content: "en-us"
  }), /*#__PURE__*/_react["default"].createElement("meta", {
    httpEquiv: "X-UA-Compatible",
    content: "IE=edge"
  }), /*#__PURE__*/_react["default"].createElement("meta", {
    name: "viewport",
    content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, shrink-to-fit=no"
  }), /*#__PURE__*/_react["default"].createElement("meta", {
    name: "robots",
    content: robots
  }), /*#__PURE__*/_react["default"].createElement("meta", {
    name: "google-site-verification",
    content: merchantId
  }), description ? /*#__PURE__*/_react["default"].createElement("meta", {
    name: "description",
    content: description
  }) : null, /*#__PURE__*/_react["default"].createElement("title", null, title ? "".concat(title, " | ").concat(name) : "".concat(name)), /*#__PURE__*/_react["default"].createElement("link", {
    href: favIcon,
    rel: "shortcut icon"
  }), /*#__PURE__*/_react["default"].createElement("noscript", null, "\n\t\t\t\t\t<iframe src={//www.googletagmanager.com/ns.html?id=".concat(gtmId, "} height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>\n\t\t\t\t")), /*#__PURE__*/_react["default"].createElement("script", null, "\n\t\t\t\t\t(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n\t\t\t\t\tnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n\t\t\t\t\tj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n\t\t\t\t\t'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n\t\t\t\t\t})(window,document,'script','dataLayer','".concat(gtmId, "');\n\t\t\t\t")));
};

Seo.defaultProps = {
  brandTag: 'law',
  description: null,
  title: null,
  robots: 'index, follow'
};
Seo.propTypes = {
  /**
   * Brand tag to use
   */
  brandTag: _propTypes["default"].oneOf(['law', 'adc', 'vir', 'wpe']).isRequired,

  /**
   * seo description for the page
   */
  description: _propTypes["default"].string,

  /**
   *
   */
  robots: _propTypes["default"].string,

  /**
   * Title tag for the page
   */
  title: _propTypes["default"].string
};
var _default = Seo;
exports["default"] = _default;